import * as React from 'react';

interface DemoAccountContextProviderType {
  isDemo: boolean;
}

const DemoAccountContext = React.createContext<DemoAccountContextProviderType | undefined>(undefined);

interface DemoAccountContextProviderProps {
  children: React.ReactNode;
  isDemo: boolean;
}

export const DemoAccountContextProvider: React.FC<DemoAccountContextProviderProps> = ({ children, isDemo }) => {
  const value = React.useMemo(() => ({ isDemo }), [isDemo]);

  return (
    <DemoAccountContext.Provider value={value}>
      {children}
    </DemoAccountContext.Provider>
  );
};

export const useDemoAccountContextProvider = (): DemoAccountContextProviderType => {
  const context = React.useContext(DemoAccountContext);
  if (context === undefined) {
    throw new Error('useDemoAccountContextProvider must be used within a DemoAccountContextProvider');
  }
  return context;
};

export default DemoAccountContextProvider;
